;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import qs from "qs";

export const TOP_LEVEL_FILTERS_URL_PARAM = "filters";

const QS_STRINGIFY_OPTIONS: qs.IStringifyOptions = {
	allowDots: true,
	delimiter: ":",
	encodeValuesOnly: true,
	indices: true,
	skipNulls: true,
};

export function stringifyTopLevelFilters(
	filters: Record<string, unknown>,
): string {
	return qs.stringify(filters, QS_STRINGIFY_OPTIONS);
}
